import styled from '@emotion/styled';

import { breakpoints } from '$variables/theme';

export const MediumUp = styled.span`
  @media (max-width: ${breakpoints.small}) {
    display: none;
  }
`;

export const SmallOnly = styled.span`
  @media (min-width: ${breakpoints.mediumStart}) {
    display: none;
  }
`;
